import { useFormContext } from 'react-hook-form';

import { DocumentController } from '@/components/Shared/ui';
import { useAppSelector } from '@/store';
import type { TFileAttached } from '@/types/financing';

import { EU_TARIFF_TYPES } from '../../../constants';
import { type FormType, fileDict } from '../../features/euras-bank-v2';

const OFFLINE_DOCUMENTS = ['certificateOrigin'];

interface IProps {
  files: Record<string, TFileAttached | undefined>;
  filesOnModeration?: Record<string, TFileAttached>;
}

const EurasOfflineDocuments: React.FC<IProps> = ({
  files,
  filesOnModeration
}) => {
  const { orderApp } = useAppSelector((state) => state.newOrder);
  const { selectedBank, isEuBankOfflineProcess } = useAppSelector(
    (state) => state.financingStep
  );

  const { control } = useFormContext<FormType>();

  const onRework = selectedBank?.status.code === 'on_rework';

  // Показывать документы только для льготного кредитования
  if (
    orderApp?.productInfo.product.eurasianTariffType !==
    EU_TARIFF_TYPES.PREFERENTIAL
  )
    return null;

  const hasOfflineDocuments = OFFLINE_DOCUMENTS.some(
    (document) => files[document] || filesOnModeration?.[document]
  );
  // Если оффлайн процесс не активен и нет оффлайн документов, то не показываем компонент
  if (!isEuBankOfflineProcess && !hasOfflineDocuments) return null;

  return (
    <DocumentController
      control={control}
      name="certificateOrigin"
      title={fileDict.certificateOrigin}
      fileLink={files.certificateOrigin?.uuid || ''}
      uploadable={!files.certificateOrigin}
      downloadable={!onRework}
      isRequired
    />
  );
};

export default EurasOfflineDocuments;
